var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudioLiteEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 126,
    viewBox: "0 0 200 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2697 76.2135C73.2836 76.2135 90.3187 59.1525 90.3187 38.1067C90.3187 17.061 73.2836 0 52.2697 0C31.2558 0 14.2207 17.061 14.2207 38.1067C14.2207 59.1525 31.2558 76.2135 52.2697 76.2135Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.14966C0 23.0144 8.68483 34.2336 19.4176 34.2336L0 9.14966Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4175 34.2336C19.4175 20.213 29.1093 8.8678 41.0864 8.8678L19.4175 34.2336Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03516 10.4065C7.03516 23.5765 12.5733 34.2336 19.4174 34.2336L7.03516 10.4065Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4175 34.2336C19.4175 16.3185 30.6197 1.82178 44.4634 1.82178L19.4175 34.2336Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3325 34.4104C15.3325 34.4104 18.0863 34.3255 18.9162 33.7336C19.7461 33.1418 23.1521 32.435 23.358 33.3842C23.5639 34.3335 27.4963 38.1052 24.3874 38.1303C21.2784 38.1555 17.1636 37.6453 16.3352 37.14C15.5069 36.6347 15.3325 34.4104 15.3325 34.4104Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.4429 37.7998C21.3339 37.825 17.219 37.3148 16.3907 36.8095C15.7599 36.4247 15.5086 35.0438 15.4245 34.4067C15.3662 34.4092 15.3325 34.4103 15.3325 34.4103C15.3325 34.4103 15.5069 36.6346 16.3352 37.1399C17.1636 37.6452 21.2784 38.1554 24.3874 38.1302C25.2848 38.123 25.5948 37.8032 25.5778 37.3296C25.4531 37.6158 25.1108 37.7944 24.4429 37.7998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4782 80.4965C53.9271 80.4965 68.8828 78.4588 68.8828 75.9451C68.8828 73.4315 53.9271 71.3938 35.4782 71.3938C17.0294 71.3938 2.07373 73.4315 2.07373 75.9451C2.07373 78.4588 17.0294 80.4965 35.4782 80.4965Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.4781 79.7662C50.9672 79.7662 63.5236 78.0554 63.5236 75.9451C63.5236 73.8347 50.9672 72.1239 35.4781 72.1239C19.989 72.1239 7.43262 73.8347 7.43262 75.9451C7.43262 78.0554 19.989 79.7662 35.4781 79.7662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.446 125.054C177.366 125.054 200 121.971 200 118.167C200 114.363 177.366 111.279 149.446 111.279C121.527 111.279 98.8931 114.363 98.8931 118.167C98.8931 121.971 121.527 125.054 149.446 125.054Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6377 111.994C98.7147 116.109 129.618 106.627 133.012 95.8929",
    stroke: "#AEB7EA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3066 46.3364C55.3066 46.3364 78.529 39.8958 79.9581 60.6488C81.3872 81.4017 66.923 107.885 83 112",
    stroke: "#AEB7EA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.103 100.766L137.696 109.764C137.696 109.764 130.768 113.45 135.639 113.559C140.51 113.667 163.458 113.559 163.458 113.559C163.458 113.559 167.896 113.559 160.86 109.656L159.453 100.224L139.103 100.766Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.659 113.461C135.765 112.475 137.696 111.448 137.696 111.448L139.103 102.45L159.453 102.469L160.86 111.34C162.501 112.25 163.518 112.947 164.112 113.483C165.016 113.276 166.003 112.509 160.86 109.656L159.453 100.224L139.103 100.766L137.696 109.764C137.696 109.764 131.874 112.862 134.659 113.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.788 38.051H106.551C104.771 38.051 103.328 39.4965 103.328 41.2795V98.7846C103.328 100.568 104.771 102.013 106.551 102.013H191.788C193.569 102.013 195.012 100.568 195.012 98.7846V41.2795C195.012 39.4965 193.569 38.051 191.788 38.051Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.927 41.4659H106.413V89.3833H191.927V41.4659Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17 40.4902C149.469 40.4902 149.711 40.2475 149.711 39.9482C149.711 39.6488 149.469 39.4061 149.17 39.4061C148.871 39.4061 148.628 39.6488 148.628 39.9482C148.628 40.2475 148.871 40.4902 149.17 40.4902Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.012 93.1776V98.7846C195.012 99.2086 194.929 99.6284 194.767 100.02C194.605 100.412 194.367 100.768 194.068 101.068C193.769 101.367 193.413 101.605 193.022 101.767C192.631 101.93 192.212 102.013 191.788 102.013H106.551C106.128 102.013 105.709 101.93 105.318 101.767C104.926 101.605 104.571 101.367 104.272 101.068C103.972 100.768 103.735 100.412 103.573 100.02C103.411 99.6284 103.328 99.2086 103.328 98.7846V93.1776H195.012Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.092 119.413V120.497H114.856V119.63L114.936 119.413L116.371 115.51H171.902L173.092 119.413Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.503 118.351C195.397 118.806 194.997 119.285 194.092 119.738C190.844 121.364 184.241 119.304 184.241 119.304C184.241 119.304 179.154 118.437 179.154 116.161C179.297 116.063 179.446 115.974 179.6 115.895C180.965 115.172 185.492 113.386 193.518 115.971C194.11 116.156 194.638 116.503 195.044 116.972C195.369 117.353 195.625 117.837 195.503 118.351Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.504 118.351C191.529 119.877 187.986 119.991 184.35 117.461C182.516 116.187 180.85 115.871 179.6 115.895C180.965 115.172 185.492 113.386 193.519 115.971C194.11 116.156 194.638 116.503 195.045 116.972C195.37 117.353 195.625 117.837 195.504 118.351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52 117.462C191.297 117.462 191.927 117.267 191.927 117.028C191.927 116.788 191.297 116.594 190.52 116.594C189.743 116.594 189.113 116.788 189.113 117.028C189.113 117.267 189.743 117.462 190.52 117.462Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17 99.6822C150.306 99.6822 151.227 98.76 151.227 97.6224C151.227 96.4848 150.306 95.5626 149.17 95.5626C148.034 95.5626 147.113 96.4848 147.113 97.6224C147.113 98.76 148.034 99.6822 149.17 99.6822Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.092 119.413V120.497H114.856V119.63L114.936 119.413H173.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5572 28.4459H19.4014V71.7409H56.5572V28.4459Z",
    fill: "#AEB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3083 24.1521H15.6499V39.5379H60.3083V24.1521Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3083 42.4004H15.6499V57.7862H60.3083V42.4004Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3083 60.6487H15.6499V76.0345H60.3083V60.6487Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.3767 26.8357H48.5186V29.6982H51.3767V26.8357Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M55.4851 26.8357H52.627V29.6982H55.4851V26.8357Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.594 26.8357H56.7358V29.6982H59.594V26.8357Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.3767 44.9052H48.5186V47.7676H51.3767V44.9052Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M55.4851 44.9052H52.627V47.7676H55.4851V44.9052Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.594 44.9052H56.7358V47.7676H59.594V44.9052Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.3767 62.9745H48.5186V65.837H51.3767V62.9745Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M55.4851 62.9745H52.627V65.837H55.4851V62.9745Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.594 62.9745H56.7358V65.837H59.594V62.9745Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6863 110.384C67.4802 110.384 73.7984 104.056 73.7984 96.2508C73.7984 88.4451 67.4802 82.1173 59.6863 82.1173C51.8924 82.1173 45.5742 88.4451 45.5742 96.2508C45.5742 104.056 51.8924 110.384 59.6863 110.384Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5431 107.343H53.2559V115.036H57.5431V107.343Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1173 107.343H61.8301V115.036H66.1173V107.343Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8285 116.467C58.8017 116.467 60.4012 115.866 60.4012 115.125C60.4012 114.384 58.8017 113.783 56.8285 113.783C54.8554 113.783 53.2559 114.384 53.2559 115.125C53.2559 115.866 54.8554 116.467 56.8285 116.467Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4028 116.288C67.3759 116.288 68.9754 115.687 68.9754 114.946C68.9754 114.205 67.3759 113.605 65.4028 113.605C63.4296 113.605 61.8301 114.205 61.8301 114.946C61.8301 115.687 63.4296 116.288 65.4028 116.288Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0438 97.5031C62.7075 97.5031 64.8669 95.3405 64.8669 92.6727C64.8669 90.0049 62.7075 87.8423 60.0438 87.8423C57.3801 87.8423 55.2207 90.0049 55.2207 92.6727C55.2207 95.3405 57.3801 97.5031 60.0438 97.5031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0437 94.2828C60.9316 94.2828 61.6514 93.5619 61.6514 92.6726C61.6514 91.7834 60.9316 91.0625 60.0437 91.0625C59.1558 91.0625 58.436 91.7834 58.436 92.6726C58.436 93.5619 59.1558 94.2828 60.0437 94.2828Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9972 83.1071C44.8577 77.9962 48.5002 72.8319 54.1329 71.5722C59.7656 70.3126 65.2556 73.4346 66.395 78.5455C67.5345 83.6564 63.8015 85.5414 58.1688 86.801C52.5361 88.0607 47.1367 88.218 45.9972 83.1071Z",
    fill: "#BD85EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9224 93.432C76.505 91.8963 79.019 89.7382 78.5377 88.6118C78.0563 87.4854 74.7618 87.8172 71.1792 89.3529C67.5966 90.8886 65.0826 93.0467 65.564 94.1731C66.0454 95.2994 69.3398 94.9676 72.9224 93.432Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 104C50.0826 102.464 52.581 99.2201 52.0997 98.0938C51.6183 96.9674 49.0826 98.4643 45.5 100C41.9174 101.536 37.0186 101.374 37.5 102.5C37.9814 103.626 42.9174 105.536 46.5 104Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9036 100.366C67.9036 101.749 64.3472 104.48 60.401 104.48C56.4547 104.48 52.7197 101.928 52.7197 100.545C52.7197 99.1613 56.4547 99.4711 60.401 99.4711C64.3472 99.4711 67.9036 98.9824 67.9036 100.366Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_1436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 125.054,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioLiteEmpty);
export default __webpack_public_path__ + "static/media/studio-lite-empty.7c332451bcf8343e5471cf66f7e53b22.svg";
export { ForwardRef as ReactComponent };